import Slug from './slug';

class OfferSlug extends Slug {
	toString() {
		return `${this.result}`;
	}
}

export default OfferSlug;
